<template>
  <div class="columns is-vcentered">
    <div class="full-width border-top-1 hoverCardHeader striped-dispositif">
        <div class="card-header-title pd-0 columns is-marginless is-justify-content-space-between">
          <div class="column is-narrow ellipsis">
            <div class="columns is-vcentered">
              <div class="column is-narrow">
                <b-icon icon="subdirectory-arrow-right" class="mgt-5px">
                </b-icon>
              </div>
              <div class="column is-narrow mgt-10px" v-if="afficherCheckbox">
                <qd-checkbox :value="dispositif.selected"
                            :indeterminate="activateIndeterminate"
                            @input="selectAllChild"></qd-checkbox>
              </div>
              <div class="column is-narrow mgt-5px pdl-0 is-cursor-pointer">
                <div @click="dispositif.open = !dispositif.open"
                :class="!dispositif.materiels || dispositif.materiels.length === 0
                ? 'disabled' : ''">
                  <b-icon :icon="dispositif.open ? 'chevron-up' : 'chevron-down'">
                  </b-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-2 ellipsis">
            <div class="columns">
              <div class="column is-narrow pdr-0 has-text-weight-bold">
                {{ $t('emplacementDispositifMaterielFacePicker.tab.dispositif') }}
              </div>
              <div class="column is-5 is-7-fullhd">
                <router-link-blank class="ellipsis"
                  :to="{ name: 'c.gabed.emplacement-detailDispositif',
             params: {
                idDispositif: dispositif.id,
                id: emplacementId,
              }}"
                  :message="dispositif.code"/>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <span>
            <span class="has-text-weight-bold">
                {{ $t('emplacementDispositifMaterielFacePicker.tab.type') }}
              </span>
            <span class="has-text-default">
                {{ getDispositifTypeLibelle(dispositif.dispositifTypeId) }}
              </span>
            </span>
          </div>
          <div class="column is-2 ellipsis">
            <span>
              <span class="has-text-weight-bold">
                {{ $t('emplacementDispositifMaterielFacePicker.tab.support') }}
              </span>
              <span class="has-text-default">
                {{ getDispositifSupport(dispositif.dispositifSupportId) }}
              </span>
            </span>
          </div>
          <div class="column is-3 ellipsis">
            <span>
              <span class="has-text-weight-bold">
                {{ $t('emplacementDispositifMaterielFacePicker.tab.confrere') }}
              </span>
              <span class="has-text-default">
                {{ confrere }}
              </span>
            </span>
          </div>
          <div class="column is-1 has-text-right">
            <b-tag type="has-background-subMenu" class="has-text-white" v-if="!dispositif.actif">
              {{$t('emplacementDispositifMaterielFacePicker.archive')}}
            </b-tag>
          </div>
        </div>
        <div class="card-content pd-10px"
             v-if="dispositif.open && dispositif.materiels
              && dispositif.materiels.length > 0">
          <ligne-materiel :afficherCheckbox="afficherCheckbox"
                          :afficherAffectation="afficherAffectation"
                          :dateDebut="dateDebut"
                          :afficherCheckboxMateriel="afficherCheckboxMateriel"
                          :selectOnlyOneObject="selectOnlyOneObject"
                          :dateFin="dateFin"
                          :afficherCheckboxFace="afficherCheckboxFace"
                          :urlImage="getImage(materiel.id)"
                          :emplacementId="emplacementId"
                          @materielSelected="checkDispositifMustBeSelectedOrNot"
                          @passToFalse="$emit('passToFalse', $event)"
                          :materiel="materiel" v-for="(materiel, index) in dispositif.materiels"
                          :key="index"
                          :displayInactif="displayInactif"
                          v-show="displayInactif || materiel.actif"></ligne-materiel>
        </div>
      </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import ligneMateriel from '@/components/gabed/general/ligneMateriel';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/general/pieceJointeConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import { get as getTiers } from '@/api/tiers/index';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ligneDispositif',
  components: {
    routerLinkBlank,
    ligneMateriel,
  },
  props: {
    index: {
      required: true,
      type: Number,
    },
    emplacementId: {
      required: true,
      default: null,
      type: String,
    },
    dispositif: {
      required: false,
      default: null,
      type: Object,
    },
    dateDebut: {
      required: true,
      type: Date,
      default: null,
    },
    dateFin: {
      required: true,
      type: Date,
      default: null,
    },
    afficherCheckbox: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxFace: {
      required: false,
      type: Boolean,
      default: true,
    },
    selectOnlyOneObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    afficherCheckboxMateriel: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherAffectation: {
      required: false,
      type: Boolean,
      default: true,
    },
    displayInactif: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imagesMateriel: [],
      confrere: null,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    selectAllChild(newStatus) {
      if (this.selectOnlyOneObject) this.$emit('passToFalse', this.dispositif.id);
      this.dispositif.selected = newStatus;
      this.$emit('dispositifSelected');
      this.dispositif.materiels.forEach((materiel) => {
        materiel.selected = this.selectOnlyOneObject ? false : newStatus;
        materiel.faces.forEach((face) => {
          face.selected = this.selectOnlyOneObject ? false : newStatus;
        });
      });
    },
    checkDispositifMustBeSelectedOrNot() {
      if (!this.afficherCheckboxMateriel) return;
      this.dispositif.selected = this.dispositif.materiels && this.dispositif.materiels
        .filter((materiel) => { return materiel.selected; }).length
        === this.dispositif.materiels.length && this.dispositif.materiels.length > 0;
      this.$emit('dispositifSelected');
    },
    getImage(materielId) {
      const imageInformationsFind = this.imagesMateriel.find((elementInformation) => {
        return elementInformation.elementId === materielId
          && elementInformation.placeType === PIECE_JOINTE_TYPE_LOGO;
      });
      if (!imageInformationsFind) return null;
      return imageInformationsFind.chemin;
    },
    getDispositifTypeLibelle(id) {
      const dispositifFind = this.parametre(PARAMETRES_KEYS.dispositifType).find((dispositif) => {
        return dispositif.id === id;
      });
      return dispositifFind ? dispositifFind.libelle : '';
    },
    getDispositifSupport(id) {
      const dispositifFind = this.parametre(PARAMETRES_KEYS.dispositifSupport)
        .find((dispositif) => {
          return dispositif.id === id;
        });
      return dispositifFind ? dispositifFind.libelle : '';
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    activateIndeterminate() {
      if (this.dispositif.selected) return false;

      return this.dispositif.materiels && this.dispositif.materiels.some((materiel) => {
        const hasFaceSelected = materiel.faces.some((face) => { return face.selected; });
        return materiel.selected === true || hasFaceSelected === true;
      });
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.dispositifType,
        PARAMETRES_KEYS.dispositifSupport]);
      this.checkDispositifMustBeSelectedOrNot();
      if (!this.dispositif.materiels) {
        return;
      }
      if (this.dispositif.tiersId) {
        this.confrere = (await getTiers(this.dispositif.tiersId)).data.result.nomCommercial;
      }
      const masterielIds = [];
      this.dispositif.materiels.forEach((materiel) => {
        masterielIds.push(materiel.id);
      });
      this.imagesMateriel = (await pGetAllPieceJointe(
        { elementsId: masterielIds, placeType: null },
      )).data.result.items;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
